import {BaseForm, name} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useMemo, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const VehicleForm = forwardRef((
  {
    company = null,
    contact = null,
    job = null,
    order,
    vehicle,
    onSaved
  }, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  const entity = useMemo(() => {
    const subject = {...vehicle};
    if (company) {
      subject.company_id = company.id;
      subject.company_name = company.name;
    } else if (subject.company) {
      subject.company_id = subject.company.id;
      subject.company_name = subject.company.name;
    }
    if (contact) {
      subject.contact_id = contact.id;
      subject.contact_name = name(contact);
    } else if (subject.contact) {
      subject.contact_id = subject.contact.id;
      subject.contact_name = name(subject.contact);
    }
    if (subject.vehicle_type) {
      subject.vehicle_type_id = subject.vehicle_type.id;
    }
    if (subject.fuel_type) {
      subject.fuel_type_id = subject.fuel_type.id;
    }
    if (subject.battery_type) {
      subject.battery_type_id = subject.battery_type.id;
    }
    if (subject.aliases) {
      subject.aliasList = subject.aliases.join('\n');
    }
    return subject;
  }, [company, contact, vehicle]);

  return (
    <BaseForm
      ref={formRef}
      entity={entity}
      type="vehicle"
      fieldsComponent={props => <Fields order={order} company={company} {...props}/>}
      onSave={useCallback((update) => {
        const attrs = {...update};
        if (company) {
          attrs['company_id'] = company.id;
        }
        if (contact) {
          attrs['contact_id'] = contact.id;
        }
        if (job) {
          attrs['job_id'] = job.id;
        }
        if (attrs['aliasList']) {
          attrs['aliases'] = attrs['aliasList'].split('\n').map(alias => alias.trim());
        } else {
          attrs['aliases'] = [];
        }
        if (attrs['aliases'].length < 1) {
          attrs['aliases'] = null;
        }
        return services.vehicle.saveVehicle(attrs);
      }, [services, company, contact, job])}
      onSaved={onSaved}
    />
  );
});

export default VehicleForm;
